import r from"./worker";function e(){const e=new Blob([r]);return URL.createObjectURL(e)}export{e as getWorkerURL};



// WEBPACK FOOTER //
// ../../../../replay-worker/build/npm/esm/index.js